import React, {Component} from 'react'
import {Transition, Grid, Checkbox, Input, Icon, Button} from 'semantic-ui-react'
import VendorOrdersDropdown from '../vendor-orders/vendor-orders-dropdown'
import {colorOptionsCads2, brandOptions, missingBrandOptions, brandOptions_org7, divisionOptions, divisionOptions_org7, categoryOptionsCads2, categoryOptionsCads2_org7, sub2OptionsCads2, subcategoryOptionsCads2, packsOptionsCads2, packsOptionsCads2_org7, sizes_org7} from '../generate-style-number/options'
import 'rheostat/initialize';
import Rheostat from 'rheostat';
import {roundTens} from './filter'
import {isCustomer, isAdmin, isSales, isSalesAssistant} from '../cads/is-role'
import {statusOptions, fabricationOptions, sizesOptions, repOptions, seasonOptions, seasonOptionsAdmin, divisionGroupOptions} from './options'
import {futureAtsMonthsOptions, next4Months} from '../cads/future_ats_months'
import warehouseOptions from '../cads/warehouse-options'
import {factoryOptions2} from '../vendor-orders/options'

class CadFilters extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sortBy != this.props.sortBy) {
      this.setState({sortByChecked: null})
    }
  }

  render() {
    let {
      fieldOnChange,
      category, subcategory, brand, division, fabrication,
      color, packs, clearFilters, usingFilters,
      minAts, maxAts, minFutureAts, maxFutureAts, maxUnits, minAge, maxAge, maxDays,
      minOnHand, maxOnHand, minPendingPo, maxPendingPo,
      updateAtsValues, updateFutureAtsValues, updateAgeValues, updateOnHandValues, updatePendingPoValues,
      contactOptions, contact, status, sortBy, sizes, season, futureAts,
      fromDateOnChange, toDateOnChange, rep, groupId, showFields,
      fromDate, toDate, warehouse, factory, sub2, orgId
    } = this.props

    let customAccess = JSON.parse(localStorage.getItem('customAccess'))

    let _brands = [], _divisions = [], _categories = [], _packs = [], _sizes = []
    if ([1,2,5].includes(orgId)) {
      _brands = brandOptions.concat(missingBrandOptions)
      _divisions = divisionOptions
      _categories = categoryOptionsCads2
      _packs = packsOptionsCads2
      _sizes = sizesOptions
    } else if (orgId == 7) {
      _brands = brandOptions_org7
      _divisions = divisionOptions_org7
      _categories = categoryOptionsCads2_org7
      _packs = packsOptionsCads2_org7
      _sizes = sizes_org7
    }

    let brandOptionsCustomAccess = customAccess != null && customAccess.brand != null ? customAccess.brand.map(y => _brands.find(x => x.key.includes(y))) : _brands
    let divisionOptionsCustomAccess = customAccess != null && customAccess.division != null ? customAccess.division.map(y => _divisions.find(x => x.key.includes(y))) : divisionGroupOptions.concat(_divisions)
    let categoryOptionsCustomAccess = customAccess != null && customAccess.category != null ? customAccess.category.map(y => _categories.find(x => x.key.split(' = ')[1] == y)).filter(Boolean) : _categories

    const packsFilter = (
      <VendorOrdersDropdown
        placeholder='Packs'
        name='packs'
        options={_packs}
        onChange={fieldOnChange}
        value={packs}
      />
    )

    const sizesFilter = (
      <VendorOrdersDropdown
        placeholder='Sizes'
        name='sizes'
        options={_sizes}
        onChange={fieldOnChange}
        value={sizes}
      />
    )

    const contactFilter = (
      isCustomer()
      ?
      <Grid.Column>
        <Input value={contact[0]} fluid disabled/>
      </Grid.Column>
      :
      <VendorOrdersDropdown
        placeholder='Contact'
        name='contact'
        options={contactOptions}
        onChange={fieldOnChange}
        value={contact}
      />
    )

    const packsSizesAndContactFilters = (
      <React.Fragment>
        {packsFilter}
        {sizesFilter}
        {contactFilter}
      </React.Fragment>
    )

    const futureAtsFilter = (
      <VendorOrdersDropdown
        placeholder='Future ATS by Month'
        name='futureAts'
        options={isCustomer() ? next4Months : futureAtsMonthsOptions}
        onChange={fieldOnChange}
        value={futureAts}
      />
    )

    const repFilter = (
      isAdmin() || isSales() || isSalesAssistant()
      ?
      <VendorOrdersDropdown
        placeholder='Rep'
        name='rep'
        options={rep == null ? repOptions.filter(x => x.key != 'All') : repOptions}
        onChange={fieldOnChange}
        value={rep}
        single={true}
      />
      :
      null
    )

    return (
      <div>
        {
          usingFilters() && !isCustomer()
          ?
          <div style={{marginTop: '10px'}}>
            <a onClick={clearFilters} className="cads-reset-filters">Reset filters</a>
          </div>
          :
          <div style={{marginTop: '10px'}}>&nbsp;</div>
        }
        <Grid stackable columns={6} style={{marginTop: '3px'}}>
          <Grid.Row>
            <VendorOrdersDropdown
              placeholder='Brand'
              name='brand'
              options={brandOptionsCustomAccess}
              onChange={fieldOnChange}
              value={brand}
            />

            <VendorOrdersDropdown
              placeholder='Division'
              name='division'
              options={divisionOptionsCustomAccess}
              onChange={fieldOnChange}
              value={division}
            />

            <VendorOrdersDropdown
              placeholder='Category'
              name='category'
              options={categoryOptionsCustomAccess}
              onChange={fieldOnChange}
              value={category}
            />

            {
              [1,2,5].includes(orgId)
              ?
              <React.Fragment>
                <VendorOrdersDropdown
                  placeholder='Sub-Category'
                  name='subcategory'
                  options={subcategoryOptionsCads2}
                  onChange={fieldOnChange}
                  value={subcategory}
                />

                <VendorOrdersDropdown
                  placeholder='Color'
                  name='color'
                  options={colorOptionsCads2}
                  onChange={fieldOnChange}
                  value={color}
                />

                {packsFilter}
              </React.Fragment>
              :
              packsSizesAndContactFilters
            }
          </Grid.Row>
          <Grid.Row>
            {
              [1,2,5].includes(orgId)
              ?
              <React.Fragment>
                <VendorOrdersDropdown
                  placeholder='Fabrication'
                  name='fabrication'
                  options={fabricationOptions}
                  onChange={fieldOnChange}
                  value={fabrication}
                />

                {sizesFilter}

                {futureAtsFilter}
              </React.Fragment>
              :
              <React.Fragment>
                <Grid.Column></Grid.Column>
                <Grid.Column></Grid.Column>
                <Grid.Column></Grid.Column>
                {futureAtsFilter}
              </React.Fragment>
            }

            <VendorOrdersDropdown
              placeholder='Season'
              name='season'
              options={isAdmin() ? seasonOptionsAdmin : seasonOptions}
              onChange={fieldOnChange}
              value={season}
            />

            {
              [1,2,5].includes(orgId)
              ?
              contactFilter
              :
              null
            }

            {
              isCustomer()
              ?
              null
              :
              <VendorOrdersDropdown
                placeholder='Status'
                name='status'
                options={status == null ? statusOptions.filter(x => x.key != 'All') : statusOptions}
                onChange={fieldOnChange}
                value={status}
                single={true}
              >
                {status == 'Shipped' &&
                  <React.Fragment>
                    <Checkbox
                      toggle
                      style={{marginTop: '8px'}}
                      label='Sort by most shipped'
                      checked={this.state.sortByChecked != null ? this.state.sortByChecked : sortBy == 'Sort by: Most shipped'}
                      onChange={(e, data) => {
                        let sortBy = data.checked ? 'Sort by: Most shipped' : 'Sort by: Name'
                        this.setState({sortByChecked: data.checked})
                        setTimeout(() => fieldOnChange(e, {name: 'sortBy', value: sortBy}), 300)
                      }}
                    />
                    <br/><br/>
                    {this.props.isAdmin &&
                      <Button basic size='small' onClick={this.props.openShippedByCustomer}>
                        <Icon name='list'/>
                        Shipped by customer
                      </Button>
                    }
                  </React.Fragment>
                }
              </VendorOrdersDropdown>
            }



            {
              [1,2,5].includes(orgId)
              ?
              null
              :
              repFilter
            }

            {
              ['PO', 'Hold', 'Shipped'].some(x => showFields.includes(x))
              ?
              <Grid.Column>
                <div style={{paddingTop: '5px'}}>
                  From <input className="cads-date-input" type="date" onChange={fromDateOnChange} value={fromDate}/>
                </div>
                <div style={{paddingTop: '5px'}}>
                  To <input className="cads-date-input" type="date" onChange={toDateOnChange} value={toDate}/>
                </div>
              </Grid.Column>
              :
              null
            }

            {
              status == 'Group ID'
              ?
              <Grid.Column>
                <Input value={groupId} fluid name='groupId' onChange={fieldOnChange} placeholder='Group ID'/>
              </Grid.Column>
              :
              null
            }
          </Grid.Row>

          {
            [1,2,5].includes(orgId)
            ?
            <Grid.Row>
              <VendorOrdersDropdown
                placeholder='Warehouse'
                name='warehouse'
                options={warehouseOptions}
                onChange={fieldOnChange}
                value={warehouse}
              />
              <VendorOrdersDropdown
                placeholder='Factory'
                name='factory'
                options={factoryOptions2}
                onChange={fieldOnChange}
                value={factory}
              />

              <VendorOrdersDropdown
                placeholder='Sub2'
                name='sub2'
                options={sub2OptionsCads2}
                onChange={fieldOnChange}
                value={sub2}
              />

              {repFilter}
            </Grid.Row>
            :
            null
          }

          <Grid.Row columns={3}>
            <Grid.Column style={status == 'Oversold' ? {height: '100px', opacity: '0.2', pointerEvents: 'none'} : {height: '100px'}}>
              <div style={{height: '50px', marginLeft: '15px', fontWeight: 'bold'}}>
                ATS <br/>
                {roundTens(minAts)} - {roundTens(maxAts)}{roundTens(maxAts) == maxUnits ? '+' : ''}
              </div>
              <div style={{width: '400px', position: 'absolute', marginLeft: '30px'}}>
                <Rheostat
                  min={0}
                  max={maxUnits}
                  values={[minAts, maxAts]}
                  onValuesUpdated={updateAtsValues}
                />
              </div>
            </Grid.Column>
            <Grid.Column>
              <div style={{height: '50px', marginLeft: '15px', fontWeight: 'bold'}}>
                {status == 'Oversold' ? 'Oversold' : 'Future ATS'} <br/>
                {roundTens(minFutureAts)} - {roundTens(maxFutureAts)}{roundTens(maxFutureAts) == maxUnits ? '+' : ''}
              </div>
              <div style={{width: '400px', position: 'absolute', marginLeft: '30px'}}>
                <Rheostat
                  min={0}
                  max={maxUnits}
                  values={[minFutureAts, maxFutureAts]}
                  onValuesUpdated={updateFutureAtsValues}
                />
              </div>
            </Grid.Column>

            {
              isCustomer()
              ?
              null
              :
              <Grid.Column style={status == 'Oversold' ? {opacity: '0.2', pointerEvents: 'none'} : {}}>
                <div style={{height: '50px', marginLeft: '15px', fontWeight: 'bold'}}>
                  Page <br/>
                  {roundTens(minAge)} - {roundTens(maxAge)}{roundTens(maxAge) == maxDays ? '+' : ''}
                </div>
                <div style={{width: '400px', position: 'absolute', marginLeft: '30px'}}>
                  <Rheostat
                    min={0}
                    max={maxDays}
                    values={[minAge, maxAge]}
                    onValuesUpdated={updateAgeValues}
                  />
                </div>
              </Grid.Column>
            }

          </Grid.Row>
          <Grid.Row columns={3}>

            {
              isCustomer()
              ?
              null
              :
              <Grid.Column style={status == 'Oversold' ? {height: '100px', opacity: '0.2', pointerEvents: 'none'} : {height: '100px'}}>
                <div style={{height: '50px', marginLeft: '15px', fontWeight: 'bold'}}>
                  On Hand <br/>
                  {roundTens(minOnHand)} - {roundTens(maxOnHand)}{roundTens(maxOnHand) == maxUnits ? '+' : ''}
                </div>
                <div style={{width: '400px', position: 'absolute', marginLeft: '30px'}}>
                  <Rheostat
                    min={0}
                    max={maxUnits}
                    values={[minOnHand, maxOnHand]}
                    onValuesUpdated={updateOnHandValues}
                  />
                </div>
              </Grid.Column>
            }

            {
              isCustomer()
              ?
              null
              :
              <Grid.Column style={status == 'Oversold' ? {height: '100px', opacity: '0.2', pointerEvents: 'none'} : {height: '100px'}}>
                <div style={{height: '50px', marginLeft: '15px', fontWeight: 'bold'}}>
                  Pending PO <br/>
                  {roundTens(minPendingPo)} - {roundTens(maxPendingPo)}{roundTens(maxPendingPo) == maxUnits ? '+' : ''}
                </div>
                <div style={{width: '400px', position: 'absolute', marginLeft: '30px'}}>
                  <Rheostat
                    min={0}
                    max={maxUnits}
                    values={[minPendingPo, maxPendingPo]}
                    onValuesUpdated={updatePendingPoValues}
                  />
                </div>
              </Grid.Column>
            }

          </Grid.Row>
        </Grid>
      </div>
    )
  }
}

export default CadFilters
